import { useEffect, useState } from 'react'

export const useWindowResize = () => {
  const initialSize = typeof window !== 'undefined' ? [window.innerWidth, window.innerHeight] : [0, 0]
  const [size, setSize] = useState<[number, number]>(initialSize as [number, number])

  useEffect(() => {
    const handler = () => {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [])

  return size
}
